export default __webpack_public_path__ + "static/media/close.d12af6ea.png";